import rest from "../script/rest";

class RunnerRest {

    async getAll() {
        const url = "/rest/runner/getAll";
        const response = await rest.get(url);
        return response.json();
    }

    async cancel(runnerId) {
        const url = "/rest/runner/cancel"
            + "?runnerId=" + runnerId;
        await rest.get(url);
    }

    async shutdown(runnerId) {
        const url = "/rest/runner/shutdown"
            + "?runnerId=" + runnerId;
        await rest.get(url);
    }

    async shutdownAll() {
        const url = "/rest/runner/shutdownAll";
        await rest.get(url);
    }

}
const runnerRest = new RunnerRest();
window.runnerRest = runnerRest;
export default runnerRest;